import { Contract, ContractInterface, ethers, Signer } from 'ethers';

export default abstract class BaseContract {
    contract: Contract;

    constructor(
        contractAddress: string,
        abi: ContractInterface,
        signer: Signer | ethers.providers.Provider
    ) {
        this.contract = new ethers.Contract(contractAddress, abi, signer);
    }

    protected async callFunction(
        functionName: string,
        args: any[] = [],
        options: ethers.PayableOverrides = {},
        extraGas: number = 5000
    ): Promise<any> {
        const functionFragment = this.contract.interface.getFunction(functionName);
        
        if (!functionFragment) {
            throw new Error(`Function ${functionName} not found in the contract ABI.`);
        }

        const stateMutability = functionFragment.stateMutability;

        if (stateMutability === 'view' || stateMutability === 'pure') {
            // Read-only functions can use provider - direct call returns unwrapped value
            return await this.contract[functionName](...args, options);
        } else {
            // State-changing functions need a signer
            if (!this.contract.signer) {
                throw new Error("No signer available. Make sure you're connected to a wallet.");
            }
            
            const contractWithSigner = this.contract.connect(this.contract.signer);
            
            // Estimate gas using the estimateGas object
            const gasEstimate = await contractWithSigner.estimateGas[functionName](...args, options);
            options.gasLimit = gasEstimate.mul(120).div(100);
            
            // Direct call returns the transaction
            return await contractWithSigner[functionName](...args, options);
        }
    }
}
